import {revenueEndpoint} from './routes';
import { createEngineerDayQueryString } from './query-string-service';

export let calculateProjectedRevenue = async (engineerId, date) => {
    const res = await fetch(revenueEndpoint + "/projected" + createEngineerDayQueryString(engineerId, date));
    return await res.json();
};

export let calculateRealisedRevenue = async (engineerId, date) => {
    const res = await fetch(revenueEndpoint + "/realised" + createEngineerDayQueryString(engineerId, date));
    return await res.json();
};

export let calculate = (jobs) => {
    let total = 0;

    for (var i = 0; i < jobs.length; i++) {
        total += jobs[i].value;
    }

    return total;
};